import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.CHAT_SOUNDS}${
    endpoint !== undefined && endpoint !== null && endpoint.toString().length > 0
      ? `/${endpoint}`
      : ""
  }`

export const chatSoundsService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET /book/chat_sounds
    // -> {
    //      sounds: [{ id, name, url, byte_size, uploaded_by, ... }],
    //      settings: { users_sound, system_sound },   // выбранные звуки компании (null = по умолчанию)
    //      can_manage,
    //      limits: { max_bytes, max_count }
    //    }
    getChatSounds: builder.query({
      query: () => ({
        url: buildUrl(),
        method: "GET",
      }),
    }),

    // POST /book/chat_sounds (multipart: file) -> { sound }
    uploadChatSound: builder.mutation({
      query: (file) => {
        const formData = new FormData()
        formData.append("file", file)

        return {
          url: buildUrl(),
          method: "POST",
          body: formData,
        }
      },
      // Обновляем кэш списка вручную: не нужны tagTypes в baseApi и лишний запрос после загрузки
      async onQueryStarted(_file, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (!data?.sound) return

          dispatch(
            chatSoundsService.util.updateQueryData("getChatSounds", undefined, (draft) => {
              if (!draft.sounds.some((s) => s.id === data.sound.id)) draft.sounds.push(data.sound)
            })
          )
        } catch (_) {}
      },
    }),

    // DELETE /book/chat_sounds/:id -> { status, settings }
    // Если удалённый звук был выбран у компании, сервер сбрасывает выбор и возвращает актуальные settings.
    deleteChatSound: builder.mutation({
      query: (id) => ({
        url: buildUrl(id),
        method: "DELETE",
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          dispatch(
            chatSoundsService.util.updateQueryData("getChatSounds", undefined, (draft) => {
              draft.sounds = draft.sounds.filter((s) => s.id !== id)
              if (data?.settings) draft.settings = data.settings
            })
          )
        } catch (_) {}
      },
    }),

    // PATCH /book/chat_sounds/settings
    // body: { users_sound?, system_sound? } — id пресета ("soft"), "custom:<id>" или null (по умолчанию)
    // -> { settings }
    updateChatSoundSettings: builder.mutation({
      query: (body) => ({
        url: buildUrl("settings"),
        method: "PATCH",
        body,
      }),
      async onQueryStarted(_body, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (!data?.settings) return

          dispatch(
            chatSoundsService.util.updateQueryData("getChatSounds", undefined, (draft) => {
              draft.settings = data.settings
            })
          )
        } catch (_) {}
      },
    }),
  }),
})

export const {
  useGetChatSoundsQuery,
  useUploadChatSoundMutation,
  useDeleteChatSoundMutation,
  useUpdateChatSoundSettingsMutation,
} = chatSoundsService
